import * as z from 'zod'
const MAX_FILE_SIZE = 5000000

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp']

export const IncorporadoraFormSchema = z.object({
  id: z.number().optional(),
  nome: z.string(),
  logo: z
    .any()
    .refine((file) => {
      // console.log('file', file)
      // console.log('file?.size', file?.size)
      // console.log('MAX_FILE_SIZE', MAX_FILE_SIZE)
      // console.log('file?.size > MAX_FILE_SIZE', file?.size > MAX_FILE_SIZE)

      return file?.size <= MAX_FILE_SIZE
    }, `Max image size is 5MB.`)
    .refine(
      (file) => ACCEPTED_IMAGE_TYPES.includes(file?.type),
      'Only .jpg, .jpeg, .png and .webp formats are supported.'
    )
    .optional(),
})

export type IncorporadoraFormData = z.infer<typeof IncorporadoraFormSchema>

export const IncorporadoraUpdateFormSchema = z.object({
  id: z.number().optional(),
  nome: z.string(),
  logo: z
    .any()
    .refine((file) => {
      // console.log('file', file)
      // console.log('file?.size', file?.size)
      // console.log('MAX_FILE_SIZE', MAX_FILE_SIZE)
      // console.log('file?.size > MAX_FILE_SIZE', file?.size > MAX_FILE_SIZE)

      return file?.size <= MAX_FILE_SIZE
    }, `Max image size is 5MB.`)
    .refine(
      (file) => ACCEPTED_IMAGE_TYPES.includes(file?.type),
      'Only .jpg, .jpeg, .png and .webp formats are supported.'
    )
    .optional(),
})

export type IncorporadoraUpdateFormData = z.infer<typeof IncorporadoraUpdateFormSchema>

// Definição do esquema para arquivos
export const FilesSchema = z.array(z.any()).optional()
// Exemplo de como combinar os esquemas se necessário
// export const CombinedSchema = z.object(RealEstateLaunchSchema);

export type IncorporadoraFilesFormData = z.infer<typeof FilesSchema>
